import React from 'react';
import { ReactComponent as MinimizeIcon } from './minimize.svg';

export default {
  minimize: props => <MinimizeIcon {...props} />
};
